<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xiii"><b>ABBREVIATIONS</b></a></p><a id="page_xiii">
<table>
<tbody><tr>
<td valign="top"><p class="appr">CERL</p></td>
<td valign="top"><p class="app">Combined Erie, Reading, and Lehigh Valley Railroads (existed only in the mind of the US government)</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">Chessie</p></td>
<td valign="top"><p class="app">Chesapeake and Ohio Railway and affiliated companies, including the Baltimore and Ohio Railroad and the Western Maryland Railway</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">CNJ</p></td>
<td valign="top"><p class="app">Central Railroad of New Jersey</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">CMV</p></td>
<td valign="top"><p class="app">constitutional minimum value</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">Conrail</p></td>
<td valign="top"><p class="app">Consolidated Rail Corporation</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">CUE</p></td>
<td valign="top"><p class="app">compensable unconstitutional erosion</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">Erie</p></td>
<td valign="top"><p class="app">Erie Lackawanna Railway</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">FRA</p></td>
<td valign="top"><p class="app">Federal Railroad Administration</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">ICC</p></td>
<td valign="top"><p class="app">Interstate Commerce Commission</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">IPO</p></td>
<td valign="top"><p class="app">initial public offering</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">NRO</p></td>
<td valign="top"><p class="app">net railway operating income</p></td>
</tr>
<tr>
<td valign="top"><p class="appr"><a id="page_xiv">OCLDD</a></p></td>
<td valign="top"><p class="app">original cost less depreciation and deterioration</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">P&amp;E</p></td>
<td valign="top"><p class="app">Peoria and Eastern Railway</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">PG&amp;N</p></td>
<td valign="top"><p class="app">Philadelphia, Germantown and Norristown Railroad</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">Rail Act</p></td>
<td valign="top"><p class="app">Regional Rail Reorganization Act of 1973</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">RCNL</p></td>
<td valign="top"><p class="app">reproduction cost new less depreciation</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">Reading</p></td>
<td valign="top"><p class="app">Reading Railroad</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">SEPTA</p></td>
<td valign="top"><p class="app">Southeastern Pennsylvania Transportation Authority</p></td>
</tr>
<tr>
<td valign="top"><p class="appr">USRA</p></td>
<td valign="top"><p class="app">United States Railway Association</p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Abbreviations.vue?e9b608da